// import { Button, Form, Input, message } from "antd";
// import { useTranslation } from "react-i18next";

// import { ReturnButton } from "./components/ReturnButton";
// import { useLoginStateContext } from "./providers/LoginStateProvider";
// import './NewLoginPage.css'
// import bg from '@/assets/images/bg-theme.png';
// import person from '@/assets/images/personbg.png'
// import logo from '@/assets/images/vantageAI.png'
// import { useState } from "react";
// import { Link, useNavigate } from "react-router";
// import { LockFilled, MinusCircleOutlined, PlusCircleFilled, UserOutlined } from "@ant-design/icons";
// import { IconButton } from "@/components/icon";
// import axios from "axios";
// import { toast } from "sonner";

// function RegisterForm() {
// 	const { t } = useTranslation();
// 	// const { loginState, backToLogin } = useLoginStateContext();
// 	const [form] = Form.useForm();
// 	const { VITE_APP_URL: URL } = import.meta.env;
// 		const [username,setUsername] = useState("");
// 		const [password,setPassword] = useState("");
// 		const [email,setEmail] = useState("");
// 		const [clientName,setClientName] = useState("");
// 		const [ loading , setLoading ] = useState<boolean>(false);
// 		const navigate = useNavigate();
// 		const [ isNextClicked , setIsNextClicked ] = useState<boolean>(false);
// 		const  [registerLoading , setRegisterLoading ] = useState<boolean>(false);
// 		const [deparmentInputLenght , setDepartmentInputLenght ] = useState(0);
// 		const [ departmentDatas , setDepartmentDatas ] = useState([
// 			{
// 				name:""
// 			}
// 		])

// 		const addDepartment = () => {
//   		setDepartmentDatas(prev => [...prev, { name: "" }]);
// 		};

// 		const removeDepartment = (index: number) => {
//   		setDepartmentDatas(prev => prev.filter((_, i) => i !== index));
// 		};

// 		const updateDepartment = (index: number, value: string) => {
// 			setDepartmentDatas(prev =>
// 				prev.map((dept, i) =>
// 					i === index ? { ...dept, name: value } : dept
// 				)
// 			);
// 		};

// 	// if (loginState !== LoginStateEnum.REGISTER) return null;

// 	const onFinish = async (values: any) => {
// 		const payload = {
// 			name: username,
// 			email: email,
// 			password: password,
// 			role_id: 3, // Hardcoded to User role (3)
// 		};

// 		try {

// 			const response = await fetch(`${URL}/api/users/signup`, {
// 				method: "POST",
// 				headers: {
// 					"Content-Type": "application/json",
// 				},
// 				body: JSON.stringify(payload),
// 			});

// 			const data = await response.json();
// 			console.log("API Response:", data);

// 			if (!response.ok) {
// 				message.error(data?.message || "Registration failed. Please try again.");
// 				return;
// 			}

// 			message.success("Registration successful! Redirecting to login...");
// 			form.resetFields();
// 			setTimeout(() => navigate("/login"), 1500);
// 		} catch (error: any) {
// 			console.error("Error occurred:", error);
// 			message.error("An error occurred. Please try again later.");
// 		}
// 	};

// 	// Handle Register Client
// 	const handleRegisterClient = async()=> {
// 		try{
// 			setRegisterLoading(true)
// 			const reponse = await axios.post(`${URL}/api/users/onboarding-request`,
// 				{
// 				   "client": {
// 						"name": clientName
// 					},
// 					"admin_user": {
// 						"name": username,
// 						"email": email,
// 						"password": password,
// 						"role_id": 2
// 					},
// 					"departments": departmentDatas.filter(d => d.name.trim() !== "")
// 				}
// 			)
// 			setRegisterLoading(false)
// 			toast.success("Client Request Submitted")
// 		}catch(error){
// 			console.log(error.response.data)
// 		}
// 	}

// 	console.log(departmentDatas)
// 		return (
// 		 <div className='login-page w-screen h-screen bg-cover bg-center bg-no-repeat flex items-center relative'>

//       <div className='absolute left-0 top-0 w-full flex'>
//         <img src={bg} alt="" className="img1"/>
//         <img src={person} alt="" className="img2"/>
//       </div>

//       <div className="linear-box"></div>
//       <div className="linear-box"></div>

//       <div className='w-1/2 flex flex-col items-center justify-center z-20'>
//           <img src={logo} alt="logo"  className='w-[200px] h-[40px]'/>
//           <div style={{width: "70%" ,backgroundColor:"#171924",marginTop:"70px" ,borderColor:"#23252f"}}  className='px-6 py-4 rounded-md border'>
//             <div className='flex flex-col gap-2 p-6 px-6 border-b  border-[#23252f] -mx-6'>
//               <div className='flex items-center gap-4'>
//                 <LockFilled className='text-gray-600'/>
//                 <span className='text-2xl font-medium tracking-[0.2px] text-common-white'>Register as Client</span>
//               </div>
//               <span className='text-gray-600'>Please fill the below details</span>
//             </div>
//            {
// 						isNextClicked ?(
// 							<div className="flex flex-col  mt-4 dark-form-item">
// 								<div className="flex items-center justify-between">
// 									<span className="text-lg font-semibold">Department Details</span>
// 									<IconButton onClick={addDepartment}><PlusCircleFilled/></IconButton>
// 								</div>
// 								 <div className={departmentDatas.length > 3 ? "flex flex-wrap justify-between" : ""}>
// 										{departmentDatas.map((dept, index) => (
// 											<Form.Item
// 												key={index}
// 												layout="vertical"
// 												label={
// 													<div className="flex items-center justify-between gap-4">
// 														<span>Enter Department Name</span>
// 														{departmentDatas.length > 1 && (
// 															<IconButton onClick={() => removeDepartment(index)}>
// 																<MinusCircleOutlined />
// 															</IconButton>
// 														)}
// 													</div>
// 												}
// 												style={{
// 													marginTop: 20,
// 													width: departmentDatas.length > 3 ? "48%" : "100%"
// 												}}
// 											>
// 												<Input
// 													placeholder="Enter name"
// 													style={{ height: 40 }}
// 													value={dept.name}
// 													onChange={(e) => updateDepartment(index, e.target.value)}
// 												/>
// 											</Form.Item>
// 										))}
// 									</div>
// 								<div className="flex flex-col gap-y-3">
// 									<Button onClick={()=>setIsNextClicked(false)}>Previous Step</Button>
// 									<Button type="primary" loading={registerLoading} onClick={handleRegisterClient}>Register Client</Button>
// 								</div>
// 							</div>
// 						):(
// 							 <div className='flex flex-col  mt-10 dark-form-item'>
// 							 <Form.Item label={<span className='text-[18px] text-common-white'>Client Name</span>} layout='vertical' >
//                     <Input
//                       style={{height: 40, backgroundColor: "#212432",borderColor:"#373b45"}}
//                       placeholder='Example: Valiantlytix'
//                       // prefix={<UserOutlined style={{color:"#dedee0"}}/>}
//                       value={clientName}
//                       onChange={(e)=>setClientName(e.target.value)}
//                       className="dark-input"
//                     />
//                 </Form.Item>
// 									 <Form.Item label={<span className='text-[18px] text-common-white'>User Name</span>} layout='vertical' >
//                     <Input
//                       style={{height: 40, backgroundColor: "#212432",borderColor:"#373b45"}}
//                       placeholder='Example: John Cena'
//                       // prefix={<UserOutlined style={{color:"#dedee0"}}/>}
//                       value={username}
//                       onChange={(e)=>setUsername(e.target.value)}
//                       className="dark-input"
//                     />
//                 </Form.Item>
// 								<div className="flex w-full items-center gap-2">
// 									 <Form.Item className="w-1/2" label={<span className='text-[18px] text-common-white'>Email</span>} layout='vertical' >
//                     <Input
//                       style={{height: 40, backgroundColor: "#212432",borderColor:"#373b45"}}
//                       placeholder='Example: example@gmail.com'
//                       prefix={<UserOutlined style={{color:"#dedee0"}}/>}
//                       value={email}
//                       onChange={(e)=>setEmail(e.target.value)}
//                       className="dark-input"
//                     />
//                 	</Form.Item>
// 									<Form.Item  label={<span className='text-[18px] text-common-white'>Password</span>} className='dark-input-scope w-1/2' layout='vertical'>
// 											<Input.Password
// 												style={{height: 40, backgroundColor: "#212432",borderColor:"#373b45" }}
// 												className='dark-password'
// 												value={password}
// 												onChange={(e)=>setPassword(e.target.value)}
// 											/>
// 									</Form.Item>
// 								</div>
//                 <Button type='primary' size='large' onClick={()=>{setIsNextClicked(true)}} loading={loading} >Next</Button>
//             </div>
// 						)
// 					 }

//           </div>
//           <span className='mt-6 font-medium text-lg select-none text-common-white'>Already registered?  <Link to={"/login"}> Login</Link></span>
//           <span className='mt-6 text-[#646775] select-none'>&copy; 2025 Vantage AI. All rights reserved.</span>
//       </div>
//     </div>
// 	)
// }

// export default RegisterForm;

import { Button, Form, Input } from "antd";
import { useTranslation } from "react-i18next";
import './NewLoginPage.css';
import bg from '@/assets/images/bg-theme.png';
import person from '@/assets/images/personbg.png';
import logo from '@/assets/images/vantageAI.png';
import { useState } from "react";
import { Link } from "react-router";
import { LockFilled, MinusCircleOutlined, PlusCircleFilled, UserOutlined } from "@ant-design/icons";
import { IconButton } from "@/components/icon";
import { toast } from "sonner";
function RegisterForm() {
  const {} = useTranslation();
  const {
//     VITE_APP_URL: URL
  } = import.meta.env;
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const [clientName, setClientName] = useState("");
  const [loading] = useState<boolean>(false);
  const [isNextClicked, setIsNextClicked] = useState<boolean>(false);
  const [registerLoading, setRegisterLoading] = useState<boolean>(false);
  const [departmentDatas, setDepartmentDatas] = useState([{
    name: ""
  }]);
  const addDepartment = () => {
    setDepartmentDatas(prev => [...prev, {
      name: ""
    }]);
  };
  const removeDepartment = (index: number) => {
    setDepartmentDatas(prev => prev.filter((_, i) => i !== index));
  };
  const updateDepartment = (index: number, value: string) => {
    setDepartmentDatas(prev => prev.map((dept, i) => i === index ? {
      ...dept,
      name: value
    } : dept));
  };
  const handleRegisterClient = async () => {
    try {
      setRegisterLoading(true);
      setRegisterLoading(false);
      toast.success("Client Request Submitted");
    } catch (error) {
      console.log(error.response.data);
    }
  };
  console.log(departmentDatas);
  return <div className='login-page w-full h-screen bg-cover bg-center bg-no-repeat flex items-center justify-center lg:justify-start relative overflow-hidden'>

			{/* Background images */}
			<div className='absolute inset-0 flex w-full h-full'>
				<img src={bg} alt="" className="w-full lg:w-[55%] h-full object-cover object-left" />
				<img src={person} alt="" className="hidden lg:block w-[45%] h-full object-cover contrast-125" />
			</div>

			<div className="hidden lg:block absolute bottom-0 right-0 w-full max-w-[884px] h-[180px] z-10" style={{
      background: 'linear-gradient(to top,#000000 30%, transparent)'
    }}></div>
			<div className="hidden lg:block absolute top-0 left-[55%] w-[100px] h-full z-10" style={{
      background: 'linear-gradient(to right, #000000 15%,transparent)'
    }}></div>

			{/* Form panel — fixed screen, no scroll, scales via responsive classes for all zoom levels */}
			<div className='w-full lg:w-[55%] flex flex-col items-center justify-center z-20 px-2 sm:px-6 lg:px-8'>

				<img src={logo} alt="logo" className='w-[100px] sm:w-[140px] md:w-[170px] lg:w-[200px] h-auto object-contain' />

				<div className='w-full max-w-[260px] sm:max-w-sm md:max-w-md lg:max-w-lg xl:max-w-none xl:w-[70%] bg-[#171924] mt-2 sm:mt-4 md:mt-6 border border-[#23252f] px-2 sm:px-4 md:px-6 py-2 sm:py-3 rounded-md shadow-lg'>

					{/* Header */}
					<div className='flex flex-col gap-1 pb-2 sm:pb-3 pt-1 px-2 sm:px-4 md:px-6 border-b border-[#23252f] -mx-2 sm:-mx-4 md:-mx-6'>
						<div className='flex items-center gap-2 sm:gap-3'>
							<LockFilled className='text-gray-600 text-sm sm:text-base md:text-xl lg:text-2xl' />
							<span className='text-xs sm:text-base md:text-xl lg:text-2xl font-medium tracking-[0.2px] text-common-white'>Register as Client</span>
						</div>
						<span className='text-gray-600 text-[10px] sm:text-xs md:text-sm lg:text-base'>Please fill the below details</span>
					</div>

					{isNextClicked ? (/* ─── Step 2: Department Details ─── */
        <div className="flex flex-col mt-2 sm:mt-3 dark-form-item">
							<div className="flex items-center justify-between mb-1 sm:mb-2">
								<span className="text-xs sm:text-sm md:text-base lg:text-lg font-semibold text-common-white">Department Details</span>
								<IconButton onClick={addDepartment}><PlusCircleFilled /></IconButton>
							</div>
							<div className={departmentDatas.length > 3 ? "flex flex-wrap justify-between" : ""}>
								{departmentDatas.map((dept, index) => <Form.Item key={dept?.id || dept?._id || dept?.key || dept?.name || dept?.title || dept?.label || dept?.value || String(dept)} layout="vertical" label={<div className="flex items-center justify-between gap-2 sm:gap-4">
												<span className="text-[10px] sm:text-xs md:text-sm text-common-white">Enter Department Name</span>
												{departmentDatas.length > 1 && <IconButton onClick={() => removeDepartment(index)}>
														<MinusCircleOutlined />
													</IconButton>}
											</div>} style={{
              marginTop: 8,
              width: departmentDatas.length > 3 ? "48%" : "100%"
            }}>
                
										<Input placeholder="Enter name" style={{
                height: 28,
                backgroundColor: "#212432",
                borderColor: "#373b45"
              }} value={dept.name} onChange={e => updateDepartment(index, e.target.value)} className="dark-input" />
                
									</Form.Item>)}
							</div>
							<div className="flex flex-col gap-y-1 sm:gap-y-2 mt-1 sm:mt-2">
								<Button size="small" className="!h-7 sm:!h-8 text-xs sm:text-sm" onClick={() => setIsNextClicked(false)}>Previous Step</Button>
								<Button size="small" className="!h-7 sm:!h-8 text-xs sm:text-sm" type="primary" loading={registerLoading} onClick={handleRegisterClient}>Register Client</Button>
							</div>
						</div>) : (/* ─── Step 1: Basic Details ─── */
        <div className='flex flex-col mt-1 sm:mt-3 dark-form-item'>
							<Form.Item label={<span className='text-[10px] sm:text-xs md:text-sm lg:text-[18px] text-common-white'>Client Name</span>} layout='vertical'>
								<Input style={{
              height: 28,
              backgroundColor: "#212432",
              borderColor: "#373b45"
            }} placeholder='Valiantlytix' value={clientName} onChange={e => setClientName(e.target.value)} className="dark-input" />
              
							</Form.Item>
							<Form.Item label={<span className='text-[10px] sm:text-xs md:text-sm lg:text-[18px] text-common-white'>User Name</span>} layout='vertical'>
								<Input style={{
              height: 28,
              backgroundColor: "#212432",
              borderColor: "#373b45"
            }} placeholder='John Cena' value={username} onChange={e => setUsername(e.target.value)} className="dark-input" />
              
							</Form.Item>
							<div className="flex w-full items-start gap-1 sm:gap-2">
								<Form.Item className="w-1/2" label={<span className='text-[10px] sm:text-xs md:text-sm lg:text-[18px] text-common-white'>Email</span>} layout='vertical'>
									<Input style={{
                height: 28,
                backgroundColor: "#212432",
                borderColor: "#373b45"
              }} placeholder='example@gmail.com' prefix={<UserOutlined style={{
                color: "#dedee0"
              }} />} value={email} onChange={e => setEmail(e.target.value)} className="dark-input" />
                
								</Form.Item>
								<Form.Item label={<span className='text-[10px] sm:text-xs md:text-sm lg:text-[18px] text-common-white'>Password</span>} className='dark-input-scope w-1/2' layout='vertical'>
									<Input.Password style={{
                height: 28,
                backgroundColor: "#212432",
                borderColor: "#373b45"
              }} className='dark-password' value={password} onChange={e => setPassword(e.target.value)} />
                
								</Form.Item>
							</div>
							<Button type='primary' size='small' className='w-full !h-7 sm:!h-8 md:!h-9 text-xs sm:text-sm mt-1' onClick={() => setIsNextClicked(true)} loading={loading}>Next</Button>
						</div>)}

				</div>

				<span className='mt-2 sm:mt-3 font-medium text-[10px] sm:text-xs md:text-sm lg:text-base select-none text-common-white text-center'>Already registered? <Link to={"/login"} className='text-[#5a65dd] hover:text-white transition-colors ml-1'>Login</Link></span>
				<span className='mt-1 text-[#646775] text-[10px] sm:text-xs md:text-sm text-center select-none'>&copy; 2025 Vantage AI. All rights reserved.</span>
			</div>
		</div>;
}
export default RegisterForm;